module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ge-Ha-Ic-Jb.4251426d.png";